import React from "react";
import { SlideService } from "../../components/servicesListe/slideSerice";
import img from "../../assets/images/marketing.png";
import ServicesSection from "../../components/servicesListe/servicesSection";
import { MOAIcon } from "../../assets/icons/MOAIcon";
import { TechnologiesIcon } from "../../assets/icons/TechnologiesIcon";
import { PHPIcon } from "../../assets/icons/PHPIcon";
import { InfrastructureIcon } from "../../assets/icons/InfrastructureIcon";
import { BigDataIcon } from "../../assets/icons/BigDataIcon";
import { SEOIcon } from "../../assets/icons/SEOIcon";
import { RéseauxsociauxIcon } from "../../assets/icons/RéseauxsociauxIcon";
import { EmailingIcon } from "../../assets/icons/EmailingIcon";
const services = [
  {
    title: "Emailing & génération de leads",
    description: "Campagnes ciblées et automatisées",
    icon: <EmailingIcon />,
    variant: "white",
  },
  {
    title: "Réseaux sociaux",
    description: "Stratégie éditoriale, community management, ads",
    icon: <RéseauxsociauxIcon />,
    variant: "green",
  },

  {
    title: "Référencement naturel (SEO)",
    description:
      "Optimisation on-site et off-site pour une meilleure visibilité",
    icon: <SEOIcon />,
    variant: "green",
  },
];
export const MarketingPage = () => {
  return (
    <div>
      <SlideService
        title={"Marketing digital"}
        description={
          " Faites rayonner votre marque et générez des résultats mesurables."
        }
        img={img}
      />

      <ServicesSection services={services} />
    </div>
  );
};
